module.exports = __webpack_public_path__ + "img/cerf4.d7315553.jpg";